import PropTypes from 'prop-types';
import * as React from 'react';

type DefaultProps = {
  push?: boolean;
};

type Props = {
  to: string;
} & DefaultProps;

class Redirect extends React.Component<Props> {
  static defaultProps: DefaultProps = {
    push: false,
  };
  static contextTypes = {
    router: PropTypes.object.isRequired,
  };

  componentDidMount() {
    const { router } = this.context;
    const { to, push } = this.props;

    const navigate = push ? router.push : router.replace;
    navigate(to);
  }

  render() {
    return null;
  }
}

export default Redirect;
